import { sendPasswordResetEmail } from 'firebase/auth'
import { auth } from '../services/firebase'

export async function resetPassword(email) {
  try {
    await sendPasswordResetEmail(auth, email)
    return { success: true }
  } catch (error) {
    let errorMessage = 'Error al enviar el correo'
    if (error.code === 'auth/user-not-found') {
      errorMessage = 'No existe una cuenta con ese email'
    }
    return { success: false, error: errorMessage }
  }
}
